import script from "./StudentArriveConfirmDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./StudentArriveConfirmDialog.vue?vue&type=script&setup=true&lang=js"

import "./StudentArriveConfirmDialog.vue?vue&type=style&index=0&id=5430d812&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5430d812"]])

export default __exports__